// Nome de cada gatilho e ação do Chat Flow, num lugar só. A paleta do editor,
// o histórico e o detalhe da execução usam as mesmas chaves: antes o histórico
// mostrava o nome interno (message_created) porque os rótulos viviam só no
// editor.
const KIND_KEYS = {
  instagram_comment: 'INSTAGRAM_COMMENT',
  instagram_story_reply: 'INSTAGRAM_STORY_REPLY',
  message_created: 'MESSAGE_CREATED',
  contact_created: 'CONTACT_CREATED',
  conversation_created: 'CONVERSATION_CREATED',
  label_added: 'LABEL_ADDED',
  kanban_item_created: 'KANBAN_ITEM_CREATED',
  kanban_item_updated: 'KANBAN_ITEM_UPDATED',
  kanban_item_stage_changed: 'KANBAN_ITEM_STAGE_CHANGED',
  kanban_item_deleted: 'KANBAN_ITEM_DELETED',
  condition: 'CONDITION',
  random_split: 'RANDOM_SPLIT',
  send_message: 'SEND_MESSAGE',
  instagram_public_reply: 'INSTAGRAM_PUBLIC_REPLY',
  add_private_note: 'ADD_PRIVATE_NOTE',
  add_label: 'ADD_LABEL',
  remove_label: 'REMOVE_LABEL',
  assign_agent: 'ASSIGN_AGENT',
  assign_team: 'ASSIGN_TEAM',
  remove_agent: 'REMOVE_AGENT',
  remove_team: 'REMOVE_TEAM',
  set_custom_attributes: 'SET_CUSTOM_ATTRIBUTES',
  transfer_inbox: 'TRANSFER_INBOX',
  change_status: 'CHANGE_STATUS',
  change_priority: 'CHANGE_PRIORITY',
  wait: 'WAIT',
  http_request: 'HTTP_REQUEST',
  ai_agent: 'AI_AGENT',
  kanban_create_item: 'KANBAN_CREATE_ITEM',
  kanban_move_to_stage: 'KANBAN_MOVE_TO_STAGE',
  kanban_assign_agent: 'KANBAN_ASSIGN_AGENT',
  kanban_remove_agent: 'KANBAN_REMOVE_AGENT',
  kanban_add_note: 'KANBAN_ADD_NOTE',
  kanban_change_item_status: 'KANBAN_CHANGE_ITEM_STATUS',
};

export const workflowKindLabelKey = kind => {
  const key = KIND_KEYS[String(kind || '')];
  return key ? `CONVERSATION_WORKFLOW_EDITOR.KINDS.${key}` : null;
};

// Tipo desconhecido (removido ou de versão nova) cai no nome interno, que
// ainda ajuda o suporte a achar o bloco.
export const workflowKindLabel = (t, kind) => {
  const key = workflowKindLabelKey(kind);
  if (key) return t(key);
  return kind ? String(kind) : '';
};
